import Api from "shared/service/api/api";
import Helpers from "shared/service/helpers";

// actions
export const LOAD_STATISTICS = "loadStatistics";
export const LOAD_STATISTICS_DETAILS = "loadStatisticsDetails";
export const LOAD_SERVICE_STATISTICS = "loadServiceStatistics";
export const LOAD_SELLS_STATISTICS = "loadSellsStatistics";
export const LOAD_SELLERS_STATISTICS = "loadSellersStatistics";
export const LOAD_SELLERS_LIST_STATISTICS = "loadSellersListStatistics";

// mutations
export const SET_STATISTICS = "setStatistics";
export const SET_STATISTICS_DETAILS = "setStatisticsDetails";
export const SET_SERVICE_STATISTICS = "setServiceStatistics";
export const SET_SELLS_STATISTICS = "setSellsStatistics";
export const SET_SELLERS_STATISTICS = "setSellersStatistics";
export const SET_SELLERS_LIST_STATISTICS = "setSellersListStatistics";

const state = {
  datasets: {
    filters: {
      periodTypes: [
        {
          key: "day",
          label: "Дням",
        },
        {
          key: "week",
          label: "Неделям",
        },
        {
          key: "month",
          label: "Месяцам",
        },
      ],
    },
  },
  statistics: [],
  statisticsDetails: [],
  serviceStatistics: [],
  sellsStatistics: [],
  sellersStatistics: [],
  sellersListStatistics: [],
};

const actions = {
  [LOAD_STATISTICS]({ commit }, { date_from, date_to, period_type }) {
    Api.statistics
      .get(date_from, date_to, period_type)
      .then((response) => {
        commit(SET_STATISTICS, response.data);
      })
      .catch((e) => e);
  },
  [LOAD_STATISTICS_DETAILS]({ commit }, { date, period_type, order_state }) {
    Api.statistics
      .getDetails(date, period_type, order_state)
      .then((response) => {
        commit(SET_STATISTICS_DETAILS, response.data);
      })
      .catch((e) => e);
  },
  [LOAD_SERVICE_STATISTICS]({ commit }, { date_from, date_to, period_type }) {
    Api.statistics.service
      .get(date_from, date_to, period_type)
      .then((response) => {
        commit(SET_SERVICE_STATISTICS, response.data);
      })
      .catch((e) => e);
  },
  [LOAD_SELLS_STATISTICS]({ commit }, { date_from, date_to, period_type }) {
    Api.statistics.sells
      .get(date_from, date_to, period_type)
      .then((response) => {
        commit(SET_SELLS_STATISTICS, response.data);
      })
      .catch((e) => e);
  },
  [LOAD_SELLERS_STATISTICS]({ commit }, { date_from, date_to, period_type }) {
    Api.statistics.sellers
      .get(date_from, date_to, period_type)
      .then((response) => {
        commit(SET_SELLERS_STATISTICS, response.data);
      })
      .catch((e) => e);
  },
  [LOAD_SELLERS_LIST_STATISTICS]({ commit }, { date_from, date_to }) {
    Api.statistics.sellers
      .list(date_from, date_to)
      .then((response) => {
        commit(SET_SELLERS_LIST_STATISTICS, response.data);
      })
      .catch((e) => e);
  },
};

const mutations = {
  [SET_STATISTICS](state, statistics) {
    Object.keys(statistics).map((key) => {
      statistics[key].isTotal = key === "total";
      statistics[key].order = {
        count: statistics[key].order_count,
        item_count: statistics[key].order_item_count,
        sum: statistics[key].order_sum,
      };
      statistics[key].paid = {
        count: statistics[key].paid_count,
        item_count: statistics[key].paid_item_count,
        sum: statistics[key].paid_sum,
      };
    });

    state.statistics = Helpers.sortByKey(Object.values(statistics));
  },
  [SET_STATISTICS_DETAILS](state, details) {
    state.statisticsDetails = details;
  },
  [SET_SERVICE_STATISTICS](state, statistics) {
    state.serviceStatistics = Helpers.sortByKey(Object.values(statistics));
    Helpers.zerosToEmptyStrs(state.serviceStatistics);
  },
  [SET_SELLS_STATISTICS](state, statistics) {
    state.sellsStatistics = Helpers.sortByKey(Object.values(statistics));
    Helpers.zerosToEmptyStrs(state.sellsStatistics);
  },
  [SET_SELLERS_STATISTICS](state, statistics) {
    state.sellersStatistics = Helpers.sortByKey(Object.values(statistics));
    Helpers.zerosToEmptyStrs(state.sellersStatistics);
  },
  [SET_SELLERS_LIST_STATISTICS](state, statistics) {
    state.sellersListStatistics = statistics;
    Helpers.zerosToEmptyStrs(state.sellersListStatistics);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
